"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
var RoadmapsModel = /** @class */ (function () {
    function RoadmapsModel($http, APPURL) {
        var _this = this;
        this.show = function (id) {
            return _this.$http
                .get(_this.URLS.FETCH + "/" + id)
                .then(_this.extract);
        };
        this.create = function (request) {
            return _this.$http
                .post(_this.URLS.FETCH, request)
                .then(_this.extract);
        };
        this.update = function (id, request) {
            return _this.$http
                .put(_this.URLS.FETCH + "/" + id, request)
                .then(_this.extract);
        };
        this.delete = function (data) {
            return _this.$http
                .delete(_this.URLS.FETCH + "/" + data.id)
                .then(_this.extract);
        };
        this.addRequirement = function (id, data) {
            return _this.$http
                .post(_this.URLS.FETCH + "/" + id + "/requirements", data)
                .then(_this.extract);
        };
        this.updateRequirement = function (id, requirement_id, data) {
            return _this.$http
                .put(_this.URLS.FETCH + "/" + id + "/requirements/" + requirement_id, data)
                .then(_this.extract);
        };
        this.deleteRequirement = function (id, requirement_id) {
            return _this.$http
                .delete(_this.URLS.FETCH + "/" + id + "/requirements/" + requirement_id)
                .then(_this.extract);
        };
        this.getStudentRoadmap = function (studentId) {
            return _this.$http
                .get(_this.URLS.STUDENTS + "/" + studentId + "/roadmap-requirements")
                .then(_this.extract);
        };
        this.assignToStudent = function (studentId, roadmapId) {
            return _this.$http
                .post(_this.URLS.STUDENTS + "/" + studentId + "/roadmap", {
                roadmap_id: roadmapId,
            })
                .then(_this.extract);
        };
        this.clearStudentRoadmap = function (studentId) {
            return _this.$http
                .delete(_this.URLS.STUDENTS + "/" + studentId + "/roadmap")
                .then(_this.extract);
        };
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/roadmaps",
            STUDENTS: APPURL + "/api/v1/users/students",
        };
        this.roadmaps = [];
        this.extract = this.extract.bind(this);
    }
    RoadmapsModel.prototype.extract = function (result) {
        return result.data;
    };
    RoadmapsModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data !== null) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.extract);
        }
        return this.$http
            .get(this.URLS.FETCH + "?paging=0")
            .then(this.extract);
    };
    return RoadmapsModel;
}());
RoadmapsModel.$inject = ["$http", "APPURL"];
exports.default = RoadmapsModel;
